import Bank from "./components/Bank";

export default Bank;
